import { useDispatch } from "react-redux";
import { LI } from "../../../AbstractElements";
import { Back, Href } from "../../../Constant";
import { setBookMarkClass } from "../../../Redux-Toolkit/Reducers/BookmarkSlice";

export const BackBtn = () => {
  const dispatch = useDispatch();
  return (
    <LI className="check-button">
      <a className="f-w-500 d-block flip-back" id="flip-back" href={Href} onClick={() => dispatch(setBookMarkClass())}>{Back}</a>
    </LI>
  );
};
